/**
 * Универсальная обёртка для всех SVG-иконок проекта.
 * Использование:
 *   <Icon name="home" size={20} />
 *   <Icon name="settings" size={24} color="var(--color-accent)" />
 *
 * Все иконки в стиле Lucide / Heroicons (24x24 viewBox, stroke-based).
 * Палитра системы — оранжевый акцент, #333 основной, белый фон.
 */

import * as React from 'react'
import { ICONS } from './icons-registry'

const Icon = ({
  name,
  size = 20,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
  style = {},
  title,
  onClick,
  ...rest
}) => {
  const path = ICONS[name]
  if (!path) {
    if (
      typeof process !== 'undefined' &&
      process.env &&
      process.env.NODE_ENV !== 'production' &&
      typeof console !== 'undefined' &&
      console.warn
    ) {
      // eslint-disable-next-line no-console
      console.warn(`Icon "${name}" not found in registry`)
    }
    return null
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`unv-icon ${className}`}
      style={{ flexShrink: 0, ...style }}
      role={title ? 'img' : 'presentation'}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      onClick={onClick}
      {...rest}
    >
      {title && <title>{title}</title>}
      {path}
    </svg>
  )
}

export default Icon
